const PLACES_CATALOG = [
  {
    category: 'boba',
    label: 'Boba & Tea Shops',
    items: [
      'Asha Tea House.webp',
      'Boba Ninja.webp',
      'Chicha San Chen.webp',
      'Mochinut.webp',
      'Mr Green Bubble.webp',
      'Plentea.webp',
      'Sharetea.webp',
      'Tea Hut.webp',
    ],
  },
  {
    category: 'cafes',
    label: 'Cafés (Study Spots)',
    items: [
      '1951 Coffee Company.jpg',
      'Blue Bottle Coffee.webp',
      'Cafe Think.webp',
      'Caffe Strada.webp',
      'Haas Student Lounge.jpg',
      'Qargo Coffee Co.webp',
      'Romeos Coffee.webp',
      'Sodoi coffee.jpeg',
      'Yalis Cafe.jpg',
      'cafe milano berkeley.jpg',
    ],
  },
  {
    category: 'casual',
    label: 'Casual Restaurants (Durant Food Row)',
    items: [
      'Bears Ramen House.webp',
      'Berkeley Thai House.webp',
      'Bongo Burger.webp',
      'Cheese n Stuff.jpg',
      'Gypsys Trattoria Italiana.webp',
      'Kingpin Donuts.webp',
      'Koja Berkeley.webp',
      'La Burrita.webp',
      'Mezzo.webp',
      'Thai Basil.webp',
      'Toss Noodle Bar.webp',
    ],
  },
  {
    category: 'downtown',
    label: 'Downtown Berkeley Restaurants',
    items: [
      'Amoeba Music.jpg',
      'Angelines Louisiana Kitchen.webp',
      'Artichoke Basilles Pizza.webp',
      'Eureka Berkeley.jpg',
      'Imm Thai Street Food.webp',
      'Ramen Hiroshi.webp',
      'Sliver Pizzeria.webp',
      'Super Duper Burger.webp',
    ],
  },
  {
    category: 'quickbites',
    label: 'Quick Bites & Student Staples',
    items: [
      'Blondies Pizza.webp',
      'Chipotle.webp',
      'Cinnaholic.webp',
      'Extreme Pizza.webp',
      'Ikes Love and Sandwiches.webp',
      'Poke Parlor.webp',
      'The Flying Falafel.webp',
      'Top Dog.webp',
    ],
  },
  {
    category: 'bars',
    label: 'Bars (21+)',
    items: [
      'Cornerstone Berkeley.webp',
      'Freehouse Berkeley.webp',
      'Jupiter Berkeley.webp',
      'Raleighs.webp',
      'Spats Berkeley.webp',
      'Tap Haus.jpg',
      'Triple Rock Brewing.webp',
      'Tupper and Reed.webp',
    ],
  },
  {
    category: 'desserts',
    label: 'Dessert Spots',
    items: [
      'Crumbl Berkeley.jpg',
      'Cupcakin Bake Shop.webp',
      'Humphry Slocombe.webp',
      'Uji Time Dessert.webp',
      'Yogurt Park.webp',
    ],
  },
  {
    category: 'groceries',
    label: 'Groceries & Snacks',
    items: [
      'Berkeley Bowl.webp',
      'Berkeley Natural Grocery.jpg',
      'Fourth Street Market Hall.webp',
      'H Mart.webp',
      'Safeway Shattuck.webp',
      'Target Downtown Berkeley.webp',
      'Trader Joes Berkeley.webp',
      'Whole Foods Berkeley.webp',
    ],
  },
  {
    category: 'healthy',
    label: 'Healthy & Vegan',
    items: ['Sweetgreen.jpg', 'Vegan Mob.webp'],
  },
  {
    category: 'outdoor',
    label: 'Outdoor & Study Spots',
    items: [
      'Berkeley Fire Trails.webp',
      'Berkeley Rose Garden.webp',
      'Cesar Chavez Park.webp',
      'Faculty Glade.webp',
      'Hearst Pool.jpg',
      'Memorial Glade.jpg',
      'Redwood Grove.webp',
      'Strawberry Creek.webp',
      'The Big C.webp',
      'Tilden Park.webp',
      'UC Botanical Garden.webp',
      'Unit1 courtyard.jpg',
      'eucalyptus grove berkeley.jpg',
    ],
  },
  {
    category: 'landmarks',
    label: 'Campus Landmarks',
    items: [
      'Doe Library.webp',
      'Hearst Mining Building.webp',
      'MLK Student Union.webp',
      'Mario Savio Steps.webp',
      'Moffitt Library.webp',
      'RSF.jpg',
      'Sather Gate.webp',
      'Soda Hall.jpg',
      'South Hall.webp',
      'Sproul Plaza.webp',
      'The Campanile.webp',
      'The Greek Theatre.webp',
      'VLSB.webp',
    ],
  },
  {
    category: 'sf_landmarks',
    label: 'SF Landmarks',
    items: [
      'alcatraz sf.jpg',
      'Coit Tower SF.jpg',
      'exploratorium museum sf.jpg',
      'Ferry Building SF.jpg',
      'fishermans whart sf.jpeg',
      'Ghirardelli SF.jpg',
      'japantown square sf.webp',
      'palace of fine arts sf.jpeg',
      'Yoda Fountain square sf.jpg',
    ],
  },
  {
    category: 'sf_outdoor',
    label: 'SF Parks & Outdoor',
    items: [
      'Haight Ashbury park sf.jpg',
      'Marina Green SF.jpg',
      'Marina Green2 SF.jpg',
      'Mission Dolores Park sf.jpg',
    ],
  },
  {
    category: 'sf_cafes',
    label: 'SF Cafés',
    items: [
      'buena vista sf.jpeg',
      'Caffe Trieste Cafe SF.jpg',
      'JOE THE JUICE Cafe SF.jpeg',
      'Philz Coffee Truck.jpg',
      'Vesuvio Cafe SF.jpg',
    ],
  },
  {
    category: 'sf_restaurants',
    label: 'SF Restaurants',
    items: [
      'Flour Water Pizzeria sf.webp',
      'french laundry sf.jpg',
      'hinodeya ramen sf.jpg',
      'Stinking Rose SF.jpeg',
      'Tonys Pizza SF.jpg',
    ],
  },
  {
    category: 'sf_bars',
    label: 'SF Bars & Nightlife',
    items: [
      'Bar Darling SF.jpg',
      'Emporium Arcade Nightclub SF.jpg',
      'EndUp nightclub sf.jpg',
      'evil eye cocktail Bar SF.jpg',
      'Madrone Art Bar SF.jpg',
      'Mauna Loa Club SF.jpg',
      'midway nightclub SF.jpg',
      'Mona Lisa Restaurant Bar SF.jpeg',
      'Monroe nightclub SF.avif',
      'Royal Cuckoo Bar SF.jpeg',
      'Sullys Marina Lounge Bar SF.jpg',
      'The Interval Bar at Long Now SF.jpeg',
      'westwood Bar SF.jpg',
    ],
  },
];

function placeUrl(filename) {
  return `${process.env.PUBLIC_URL || ''}/places-google/${encodeURIComponent(filename)}`;
}

/**
 * Homepage hero sample poster only: recognizable SF + Berkeley spots.
 * Survey / place picker still uses `getVariedPlacesSample` over the full catalog.
 */
const HERO_SAMPLE_PLACE_FILES = [
  'alcatraz sf.jpg',
  'Coit Tower SF.jpg',
  'Ferry Building SF.jpg',
  'Yoda Fountain square sf.jpg',
  'Haight Ashbury park sf.jpg',
  'Philz Coffee Truck.jpg',
  'Flour Water Pizzeria sf.webp',
  'Tonys Pizza SF.jpg',
];

const heroSamplePlacePool = HERO_SAMPLE_PLACE_FILES.map((file) => {
  const imageUrl = placeUrl(file);
  const name = file.replace(/\.(png|jpg|jpeg|webp|avif)$/i, '');
  return { imageUrl, name, id: imageUrl, category: 'hero_sample' };
});

/** Random subset of the curated hero pool (same shape as `getVariedPlacesSample` items). */
export function getRandomHeroSamplePlaces(count = 3) {
  const shuffled = [...heroSamplePlacePool].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, shuffled.length));
}

export const placesCatalog = PLACES_CATALOG.map(({ category, label, items }) => ({
  category,
  label,
  items: items.map((file) => {
    const imageUrl = placeUrl(file);
    const name = file.replace(/\.(png|jpg|jpeg|webp|avif)$/i, '');
    return { imageUrl, name, id: imageUrl, category };
  }),
}));

export const allPlaces = placesCatalog.flatMap((cat) => cat.items);

/**
 * Picks one random place from each of N randomly-chosen categories,
 * guaranteeing variety across boba, cafés, restaurants, landmarks, etc.
 */
export function getVariedPlacesSample(count = 9) {
  const shuffledCats = [...placesCatalog].sort(() => Math.random() - 0.5);
  const picks = [];
  for (const cat of shuffledCats) {
    if (picks.length >= count) break;
    const item = cat.items[Math.floor(Math.random() * cat.items.length)];
    picks.push(item);
  }
  while (picks.length < count) {
    const remaining = allPlaces.filter((p) => !picks.some((pk) => pk.id === p.id));
    if (remaining.length === 0) break;
    picks.push(remaining[Math.floor(Math.random() * remaining.length)]);
  }
  return picks;
}

export const PLACES_FILES = PLACES_CATALOG.flatMap((cat) => cat.items);
